import React, { useState, useEffect } from 'react';
import Loading from '../Components/Loading';
import CensoSearch from '../Components/CensoSearch';
import CensoFilters from '../Components/CensoFilters';
import Tabs from 'react-bootstrap/Tabs';
import Tab from 'react-bootstrap/Tab';
import moment from 'moment';
import { getProcedimientosCuentas, 
        getProcedimientosCuentasRango,} from '../Services/Net/Request/CensoServices';
import ProcedurePatientList from '../Components/ProcedurePatientList';

export default function CensoPage(props)
{
    const [status, setStatus] = useState("");
    const [pservice, setPservice] = useState(0);
    const [pstatus, setPstatus] = useState(1);
    const [daterange, setDaterange] = useState(0);
    const [search, setSearch] = useState("");
    const [query, setQuery] = useState("");
    const [refresh, setRefresh] = useState(false);
    const [filters, SetFilters] = useState(false);
    const [colaps, setColaps] = useState(false);
    const [dateday, setDateday] = useState(new Date());
    const [FechaRango, setFechaRango] = useState({
        inicial: moment().startOf('day'),
        final: moment().endOf('day')
    });
    const [Cirugias, setCirugias] = useState({
        All: [],
        Pr: [],
        Ac: [],
        Ok: [],
        Ca: []
    });

    useEffect(() => {
        const abortController = new AbortController();
        setStatus("?");
        setCirugias({ All: [], Pr: [], Ac: [], Ok: [], Ca: [] });

        var promise = null;
        const formatdate = "YYYY-MM-DD HH:mm:ss";

        switch(pstatus)
        {
            case 1: //Fecha
                promise = getProcedimientosCuentasRango(abortController.signal, FechaRango.inicial.format(formatdate), FechaRango.final.format(formatdate))
            break;
            default:
                promise = getProcedimientosCuentas(abortController.signal);
        }

        promise.then((response)=>{
            if (abortController.signal.aborted)
                return;
            
            if (response.ok)
            {
                setStatus("");
                response.json().then((data) => {
                    var patients = pservice===0 ? data : 
                        (pservice===1 ? data.filter(f => f.Servicio_medico !== "PARTICULAR") :
                        data.filter(f => f.Servicio_medico === "PARTICULAR"));
                    
                    if (query!=="")
                        patients = patients.filter(f => 
                            f.Fullname.toLowerCase().includes(query.toLowerCase())
                            || f.DoctorCirugia.toLowerCase().includes(query.toLowerCase())
                            || f.NombreCirugia.toLowerCase().includes(query.toLowerCase()));
                    
                    setCirugias({
                        All: patients,
                        Pr: patients.filter((a) => a.StatusCirugia === 1),
                        Ac: patients.filter((a) => a.StatusCirugia === 4),
                        Ok: patients.filter((a) => a.StatusCirugia === 2),
                        Ca: patients.filter((a) => a.StatusCirugia === 3)
                    });
                });
            }  else {
                setStatus("Error de conexión");
            }
        });
    },[pservice,pstatus,refresh,query,FechaRango,props.hospital]);

    function Search()
    {
        if(search==="")
            setRefresh(!refresh)
            else
            setQuery(search);
    }

    function EnterSearch(e)
    {
        if (e.key === 'Enter')
            setQuery(search);
    }

    function ChangeDateRange(value)
    {
        switch(value)
        {
            case 0://hoy
                    setFechaRango({
                        inicial:moment().startOf('day'),
                        final:moment().endOf('day')
                    });
                break;
            case 1://ayer
                    setFechaRango({
                        inicial:moment().subtract(1, 'days').startOf('day'),
                        final:moment().subtract(1, 'days').endOf('day')
                    });
                break;
            case 2://semana
                    setFechaRango({
                        inicial:moment().startOf('isoWeek'),
                        final:moment().endOf('isoWeek')
                    });
                break;
            case 3://dia
                    setFechaRango({
                        inicial:moment(dateday).startOf('day'),
                        final:moment(dateday).endOf('day')
                    });
                break;
            default:
                {
                    setFechaRango({
                        inicial:moment().startOf('day'),
                        final:moment().endOf('day')
                    });
                }
        }
        setDaterange(value);
    }

    function ChangeDateDay(date)
    {
        setFechaRango({
            inicial:moment(date).startOf('day'),
            final:moment(date).endOf('day')
        });
        setDateday(date);
    }

    const TxtService = ["Todos","Asegurado","Particular"];
    const TxtStatus = ["Visitas","Fecha"];
    const TxtDate = ["Hoy","Ayer","Semana","Dia"];

    const filterdata = { 
        colaps, 
        dateday, 
        daterange, 
        pstatus, 
        pservice, 
        TxtService,
        TxtStatus,
        TxtDate };

    return(
    <section>
        <CensoSearch
            filteron={filters}
            search={search}
            setFilteron={(ison) => SetFilters(ison)}
            setSearch={(v) => setSearch(v)}
            SearchQuery={() => Search()}
            entrysearch={EnterSearch}/>
        <CensoFilters
            {...filterdata}
            setDateday={(v) => ChangeDateDay(v)}  
            setDaterange={(v) => ChangeDateRange(v)}
            setPstatus={(v) => setPstatus(v)}
            setPservice={(v) => setPservice(v)}
            setColaps={(ison) => setColaps(ison)}
            groupLabel="Solo Salas"
            show={filters}/>
        <div className='tc'>
            <Loading status={status}/>
        </div>
        <Tabs defaultActiveKey="all" transition={false} id="noanim-tab-example" hidden={status === "?"}>
            <Tab eventKey="all" title={'Todas ('+(Cirugias.All.length)+')'}>
                <ProcedurePatientList active={colaps} pdata={Cirugias.All} />
            </Tab>
            <Tab eventKey="pro" title={'Programadas ('+Cirugias.Pr.length+')'}>
                <ProcedurePatientList active={colaps} pdata={Cirugias.Pr} />
            </Tab>
            <Tab eventKey="act" title={'Activas ('+Cirugias.Ac.length+')'}>
                <ProcedurePatientList active={colaps} pdata={Cirugias.Ac} />
            </Tab>
            <Tab eventKey="con" title={'Concluidas ('+Cirugias.Ok.length+')'}>
                <ProcedurePatientList active={colaps} pdata={Cirugias.Ok} />
            </Tab>
            <Tab eventKey="can" title={'Canceladas ('+Cirugias.Ca.length+')'}>
                <ProcedurePatientList active={colaps} pdata={Cirugias.Ca} />
            </Tab>
        </Tabs>
        
    </section>);
}